export const useCheckout = () => {
  const { t } = useI18n();
  const activeCheckoutStep = useState('activeCheckoutStep', () => 1);
  // selectedServices is an object with keys as shape_id and values as an array of selected services from checkout.reservation.units[].available_services
  const selectedServices = useState('selectedServices', () => ({}));
  const cleanFormData = {
    title: t('title.madam'),
    first_name: '',
    last_name: '',
    email: '',
    confirmEmail: '',
    address: '',
    city: '',
    zip: '',
    country_code: undefined,
    phone: '',
    dial_code: '+385',
    phone_number: '',
    birth_date: '0000-00-00',
  };

  const checkout = useState('checkout', () => ({
    reservation: {},
    comments: '',
    termsAccepted: false,
    loyaltyTerms: false,
    form: JSON.parse(JSON.stringify(cleanFormData)),
    formErrors: {},
  }));

  onMounted(() => {
    selectedServices.value = sessionStorage.getItem('selectedServices') ? JSON.parse(sessionStorage.getItem('selectedServices')) : {};
    if (checkout.value?.reservation?.units) {
      for(const item of checkout.value.reservation?.units) {
        if(!selectedServices.value[item.details.shape_id]) selectedServices.value[item.details.shape_id] = item.price_items?.filter(i => i.kind === 'SUPPLEMENT');
      }
    }
  })

  function setCleanFormData() {
    checkout.value.form = JSON.parse(JSON.stringify(cleanFormData));
  }
  
  watch(selectedServices, () => {
    if(import.meta.client) sessionStorage.setItem('selectedServices', JSON.stringify(selectedServices.value));
    for(const key in selectedServices.value) {
      if(!selectedServices.value[key]) selectedServices.value[key] = []
    }
  }, { deep: true })
  
  return {
    activeCheckoutStep,
    checkout,
    selectedServices,
    
    setCleanFormData,
  }
}